import { Model } from 'mobx-rest'

export class uploadTestLocations extends Model {
    constructor(attributes) {
        const params = {
            "file": null,
        }
        super(Object.assign(params, attributes))
    }
    urlRoot() {
        return '/caf-II/uploadTestLocations'
    }
}
